import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AddProviderDialogComponent } from '../../providers/add-provider-dialog/add-provider-dialog.component';
import { Dialog } from '@angular/cdk/dialog';

@Component({
  selector: 'admin-portal-portal-header',
  imports: [MatIconModule],
  templateUrl: './portal-header.component.html',
})
export class AdminPortalHeaderComponent {
  private readonly dialog = inject(Dialog);

  openAddProviderDialog(): void {
    this.dialog.open(AddProviderDialogComponent);
  }
}
